import React from "react";
import { Facebook, Instagram, MapPin, Phone, Mail, Clock } from "lucide-react";
import { restaurant } from "../mock";

const Footer = () => (
  <footer className="bg-[#0E2A2A] text-gray-300 mt-10">
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
      <div className="md:col-span-1">
        <div className="flex items-center gap-3 mb-3">
          <img
            src="https://customer-assets.emergentagent.com/job_baan-mae-dining/artifacts/vhgsy54x_Logo%20BAAN%20MAE%20seul.webp"
            alt="BAAN MAE logo"
            className="h-14 w-auto object-contain brightness-125"
          />
        </div>
        <p className="text-sm text-gray-400 leading-relaxed">
          Un voyage culinaire au cœur de la Thaïlande, à Bougival. Cuisine maison, produits frais, accueil chaleureux.
        </p>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-3">Navigation</h4>
        <ul className="space-y-2 text-sm">
          <li><a href="#a-propos" className="hover:text-white transition-colors">À propos</a></li>
          <li><a href="#menu" className="hover:text-white transition-colors">Menu</a></li>
          <li><a href="#avis" className="hover:text-white transition-colors">Avis</a></li>
          <li><a href="#localisation" className="hover:text-white transition-colors">Nous trouver</a></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-3">Contact</h4>
        <ul className="space-y-2 text-sm">
          <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-[#5FB3A8] mt-0.5 flex-shrink-0" />{restaurant.address}</li>
          <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#5FB3A8] flex-shrink-0" /> 06 32 18 35 54</li>
          <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#5FB3A8] flex-shrink-0" /> lchainoy27@gmail.com</li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-3 flex items-center gap-2"><Clock className="h-4 w-4 text-[#5FB3A8]" /> Horaires</h4>
        <ul className="space-y-1.5 text-sm text-gray-400">
          <li>Lun. - Sam. : 19:00 - 22:30</li>
          <li>Dim. : 12:00 - 14:30</li>
        </ul>
        <div className="flex items-center gap-3 mt-4">
          <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-[#5FB3A8] transition-colors"><Facebook className="h-4 w-4" /></a>
          <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-[#5FB3A8] transition-colors"><Instagram className="h-4 w-4" /></a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 text-xs text-gray-400 flex flex-col md:flex-row justify-between gap-2">
        <span>© 2026 BAAN MAE — Restaurant Thaïlandais à Bougival</span>
        <span>Tous droits réservés · Mentions légales · Confidentialité</span>
      </div>
    </div>
  </footer>
);

export default Footer;
